const HOME_PATH = '/';
const B2C_ORDERS_PATH = '/orders';
const B2C_LEGACY_ORDERS_PATH = '/legacy-orders';
const B2B_ORDERS_PATH = '/leafio-orders';
const REPORTS_PATH = '/reports';
const ACCOUNT_PATH = '/account';
const LOGIN_PATH = `${ACCOUNT_PATH}/login`;
const LOGOUT_PATH = `${ACCOUNT_PATH}/logout`;
const FORGOT_PASSWORD_PATH = `${ACCOUNT_PATH}/forgot-password`;
const RESET_PASSWORD_PATH = `${ACCOUNT_PATH}/reset-password`;

export {
  ACCOUNT_PATH,
  B2B_ORDERS_PATH,
  B2C_LEGACY_ORDERS_PATH,
  B2C_ORDERS_PATH,
  FORGOT_PASSWORD_PATH,
  HOME_PATH,
  LOGIN_PATH,
  LOGOUT_PATH,
  REPORTS_PATH,
  RESET_PASSWORD_PATH,
};
